module.exports = __webpack_public_path__ + "img/camera.2399ebe0.svg";